import { routeMeta, usePageMeta } from "../../lib/usePageMeta";

const SOLUTIONS = [
  { icon: "🏛️", title: "Government contractors", body: "FAR/DFARS applicability, flow down verification, option year tracking, and CMMC/DCAA evidence." },
  { icon: "⚖️", title: "Legal teams", body: "Clause playbooks, redlining, approvals, and a grounded assistant that always cites its sources." },
  { icon: "💼", title: "Procurement & vendor management", body: "Counterparty relationships, renewal calendars, and obligation ownership across the portfolio." },
  { icon: "🏦", title: "Finance & operations", body: "ROI analytics, actuals reconciliation, seat and usage governance under one billing account." },
];

export function Solutions() {
  usePageMeta(routeMeta("/solutions"));
  return (
    <section className="section">
      <div className="container">
        <div className="section__head">
          <h1>Governed AI for the work that gets audited</h1>
          <p>Odingard Studio adapts to how regulated teams actually work.</p>
        </div>
        <div className="feature-grid">
          {SOLUTIONS.map((s) => (
            <div className="feature" key={s.title}>
              <div className="feature__icon" aria-hidden="true">
                {s.icon}
              </div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
